import React, { useState, useEffect } from "react";
import { fetchDataFromAPI, saveData, deleteData } from "../components/api.js";
import subscriptionStatus from "../components/SubscriptionStatus.js";
import { useTheme } from "../context/ThemeContext.js";
import Pagination from "../components/Pagination.js";
import axios from "axios";
import config from "../config";
import dayjs from "dayjs";
const baseUrl = config.baseURL;
const Complaint = () => {
  const [complaints, setComplaints] = useState([]);
  const [modules, setModules] = useState([
    "dashboard",
    "customer",
    "categories",
    "complaint",
    "earnings",
    "expenses",
    "faqs",
    "invoice",
    "materials",
    "orders",
    "pages",
    "ProductionBatch",
    "products",
    "rewardPoints",
    "ShippingCompany",
    "suppliers",
    "rewardsettings",
    "pricing",
    "edit profile",
    "change password",
    "logout",
  ]);
  const [newComplaint, setNewComplaint] = useState({
    photo: "",
    module: "",
    comment: "",
  });
  const [replies, setReplies] = useState({});
  const [totalPages, setTotalPages] = useState(1);
  const [expandedReplies, setExpandedReplies] = useState({});
  const [totalComplaints, setTotalComplaints] = useState();
  const [replyInputVisibility, setReplyInputVisibility] = useState({});
  const [replyText, setReplyText] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [filters, setFilters] = useState({});
  const [sortField, setSortField] = useState("created_at");
  const [sortOrder, setSortOrder] = useState("DESC");
  const isSubscribed = subscriptionStatus();
  const { theme } = useTheme();

  // Colors based on final color breakdown
  const backgroundColor = "#F4F6F9"; // Light grayish background for dashboard
  const textColor = "#333333"; // Dark gray for text
  const buttonColor = "#2E4053"; // Dark blue for buttons
  const secondaryButtonColor = "#A6AAAD"; // Muted grayish-blue for secondary buttons
  const tableRowColorEven = "#FFFFFF"; // White for even rows
  const tableRowColorOdd = "#F8F9FC"; // Light grayish-blue for odd rows
  const headerBackgroundColor = "#2E4053"; // Dark blue for header
  const tableBorderColor = "#D1D8E0"; // Light gray for table borders

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async (page = 1, itemsPerPage = 10, filters = {}) => {
    try {
      const token = localStorage.getItem("token");
      const filterParamsObj = { page, limit: 10, ...filters };

      if (sortField) filterParamsObj.sortField = sortField;
      if (sortOrder) filterParamsObj.sortOrder = sortOrder;

      const filterParams = new URLSearchParams(filterParamsObj).toString();
      const { data: complaintsData, pagination } = await fetchDataFromAPI(
        `/api/complain-user`,
        filterParams,
        token
      );

      setComplaints(Array.isArray(complaintsData) ? complaintsData : []);
      setTotalPages(pagination?.totalPages || 1);
      setTotalComplaints(pagination?.totalComplaints);
      console.log("complaintsData", complaintsData);
    } catch (err) {
      console.error("Error fetching complaints:", err.message);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewComplaint({ ...newComplaint, [name]: value });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      console.log("Selected file:", file);
      setNewComplaint({ ...newComplaint, photo: file });
    } else {
      console.error("No file selected");
    }
  };

  const submitComplaint = async (e) => {
    try {
      e.preventDefault();
      const formData = new FormData();
      formData.append("complaints_photos", newComplaint.photo);
      formData.append("module", newComplaint.module);
      formData.append("comment", newComplaint.comment);
      console.log("newComplaint", newComplaint);
      const token = localStorage.getItem("token");

      const response = await axios.post(`${baseUrl}/api/complain`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      console.log("response", response);
      // console.log("Photo URL:", response.data.photo);

      if (response && response.data.photo) {
        // Store the photoUrl from the response and display it
        setComplaints([
          ...complaints,
          {
            ...newComplaint,
            photo: response.data.photo, // Use the correct URL for the photo
            created_at: response.data.created_at,
          },
        ]);
        console.log("Uploading file:", response.data.photo);

        setNewComplaint({
          photo: "",
          module: "",
          comment: "",
        });
        document.getElementById("photoInput").value = "";
        document.getElementById("moduleInput").value = "";
        document.getElementById("commentInput").value = "";
        // Optionally show a success message (can use alert, toast, or any custom component)
        alert("Complaint submitted successfully!");
        console.log("setNewComplaint", newComplaint);
      }
      // alert("Complaint submitted successfully!");
    } catch (error) {
      console.error("Error submitting complaint:", error);
      alert("Failed to submit complaint. Please try again later.");
    }
  };

  // const replyToComplaint = async (complaintId, reply, parentReplyId = null) => {
  //   try {
  //     await saveData(`/api/complaints/${complaintId}/reply`, {
  //       reply,
  //       parentReplyId,
  //     });
  //     fetchData();
  //   } catch (error) {
  //     console.error("Error replying to complaint:", error);
  //   }
  // };

  const toggleReplies = (complaintId) => {
    setExpandedReplies((prev) => ({
      ...prev,
      [complaintId]: !prev[complaintId],
    }));
  };

  // // Toggle visibility of reply input for a specific reply
  // const toggleReplyInput = (complaintId, replyId = null) => {
  //   setReplies((prev) => ({
  //     ...prev,
  //     [complaintId]: {
  //       ...prev[complaintId],
  //       replyId: !prev[complaintId]?.replyId,
  //     },
  //   }));
  // };
  const toggleReplyInput = (complaintId, replyId) => {
    setReplyInputVisibility((prev) => ({
      ...prev,
      [`${complaintId}_${replyId}`]: !prev[`${complaintId}_${replyId}`],
    }));
  };

  // Handle reply input change
  const handleReplyInputChange = (e, complaintId, replyId) => {
    const { value } = e.target;
    setReplyText((prev) => ({
      ...prev,
      [`${complaintId}_${replyId}`]: value,
    }));
  };

  const replyToComplaint = async (complaintId, reply, parentReplyId) => {
    try {
      console.log("replyToComplaint", complaintId, reply, parentReplyId);
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${baseUrl}/api/complain/reply/${complaintId}`,
        {
          reply,
          parent_reply_id: parentReplyId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`, // Include token in request header
          },
        }
      );

      console.log("Reply submitted successfully:", response.data);
      fetchData(); // Fetch updated complaints after replying
    } catch (error) {
      console.error("Error replying to complaint:", error);
      alert("Failed to submit your reply. Please try again.");
    }
  };
  const toggleRepliesVisibility = (replyId) => {
    setExpandedReplies((prev) => ({
      ...prev,
      [replyId]: !prev[replyId], // Toggle the visibility of replies for this specific reply
    }));
  };

  return (
    <div
      style={{
        maxWidth: "800px",
        margin: "auto",
        padding: "32px",
        backgroundColor: backgroundColor,
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        borderRadius: "12px",
        border: `1px solid ${tableBorderColor}`, // Light gray border
      }}
    >
      <h1
        style={{
          fontSize: "32px",
          fontWeight: "bold",
          marginBottom: "24px",
          textAlign: "center",
          color: headerBackgroundColor, // Dark blue for header
        }}
      >
        Complaint Management
      </h1>
      <div
        style={{
          backgroundColor: backgroundColor,
          padding: "24px",
          borderRadius: "12px",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
          border: `1px solid ${tableBorderColor}`,
          marginBottom: "24px",
        }}
      >
        <h2
          style={{
            fontSize: "24px",
            fontWeight: "600",
            marginBottom: "16px",
            color: textColor, // Dark gray for text
          }}
        >
          Submit a Complaint
        </h2>
        <input
          type="file"
          onChange={handleFileChange}
          id="photoInput"
          style={{
            width: "100%",
            padding: "12px",
            border: "1px solid #D1D5DB",
            borderRadius: "8px",
            marginBottom: "12px",
          }}
        />
        <select
          name="module"
          onChange={handleInputChange}
          id="moduleInput"
          style={{
            width: "100%",
            padding: "12px",
            border: "1px solid #D1D5DB",
            borderRadius: "8px",
            marginBottom: "12px",
            backgroundColor: backgroundColor,
          }}
        >
          <option value="">Select Module</option>
          {modules.map((mod) => (
            <option key={mod} value={mod}>
              {mod}
            </option>
          ))}
        </select>
        <textarea
          name="comment"
          onChange={handleInputChange}
          id="commentInput"
          placeholder="Enter your complaint"
          style={{
            width: "96%",
            padding: "12px",
            border: "1px solid #D1D5DB",
            borderRadius: "8px",
            marginBottom: "12px",
            backgroundColor: backgroundColor,
          }}
        ></textarea>
        <button
          onClick={submitComplaint}
          style={{
            width: "100%",
            backgroundColor: buttonColor, // Dark blue for primary button
            color: "white",
            padding: "12px",
            borderRadius: "8px",
            cursor: "pointer",
            transition: "background-color 0.3s",
          }}
          onMouseOver={(e) => (e.target.style.backgroundColor = "#1E40AF")}
          onMouseOut={(e) => (e.target.style.backgroundColor = buttonColor)}
        >
          Submit
        </button>
      </div>
      <h2
        style={{
          fontSize: "24px",
          fontWeight: "600",
          marginBottom: "16px",
          color: textColor, // Dark gray for text
        }}
      >
        Complaints List
      </h2>{" "}
      {complaints?.length > 0 ? (
        complaints?.map((complaint, index) => (
          <div
            key={complaint.id}
            style={{
              backgroundColor:
                index % 2 === 0 ? tableRowColorEven : tableRowColorOdd, // Alternating row colors
              padding: "24px",
              borderRadius: "12px",
              border: `1px solid ${tableBorderColor}`,
              marginBottom: "16px",
            }}
          >
            <p>
              <strong>Module:</strong> {complaint.module}
            </p>
            <p>
              <strong>Comment:</strong> {complaint.comment}
            </p>
            {complaint.photo && (
              <img
                src={complaint.photo}
                alt="Complaint"
                style={{ width: "112px", height: "112px", borderRadius: "8px" }}
              />
            )}
            <p
              style={{
                color: complaint.resolved ? "green" : "red",
                fontWeight: "bold",
                textAlign: "right",
              }}
            >
              {complaint.resolved ? "Resolved" : "Not Resolved"}
            </p>

            <p style={{ fontSize: "12px", color: "gray", textAlign: "right" }}>
              Created at:{" "}
              {complaint.created_at
                ? dayjs(complaint.created_at).format("YYYY-MM-DD HH:mm:ss")
                : "N/A"}
            </p>

            {complaint.replies?.length > 0 && (
              <div style={{ textAlign: "left" }}>
                <button
                  onClick={() => toggleReplies(complaint.id)}
                  style={{
                    cursor: "pointer",
                    color: "#1A202C",
                    fontWeight: "bold",
                    background: "transparent",
                    border: "none",
                    textDecoration: "underline",
                    fontSize: "14px",
                  }}
                >
                  {expandedReplies[complaint.id]
                    ? "Hide Replies"
                    : `Show Replies (${complaint.replies.length})`}
                </button>
                {expandedReplies[complaint.id] && (
                  <div
                    style={{
                      marginTop: "10px",
                      paddingLeft: "20px",
                      borderLeft: `2px solid ${tableBorderColor}`,
                      position: "relative",
                      maxHeight: "400px", // Set a max height for scrolling
                      overflowY: "auto", // Enable vertical scrolling
                    }}
                  >
                    {complaint.replies.map((reply) => (
                      <div key={reply.id} style={{ marginBottom: "16px" }}>
                        {/* Reply Container */}
                        <div
                          style={{
                            padding: "16px",
                            backgroundColor: "#F7F9FC",
                            borderRadius: "8px",
                            border: `1px solid ${tableBorderColor}`,
                            marginBottom: "10px",
                            position: "relative",
                            boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
                            paddingLeft: `${20 * reply.level}px`, // Dynamically increase padding based on level
                          }}
                        >
                          <p
                            style={{
                              fontSize: "14px",
                              color: "#333",
                              marginBottom: "8px",
                            }}
                          >
                            {reply.reply}
                          </p>
                          <p
                            style={{
                              fontSize: "12px",
                              color: "gray",
                              textAlign: "right",
                            }}
                          >
                            Created at:{" "}
                            {new Date(reply.created_at).toLocaleString()}
                          </p>

                          {/* Reply Button */}
                          <button
                            onClick={() =>
                              toggleReplyInput(complaint.id, reply.id)
                            }
                            style={{
                              cursor: "pointer",
                              color: "#2E4053",
                              fontSize: "14px",
                              position: "absolute",
                              right: "12px",
                              bottom: "12px",
                              border: "none",
                              background: "transparent",
                            }}
                          >
                            Reply
                          </button>

                          {/* Input for replying to the reply */}
                          {replyInputVisibility[
                            `${complaint.id}_${reply.id}`
                          ] && (
                            <div style={{ marginTop: "12px" }}>
                              <textarea
                                placeholder="Enter your reply"
                                value={
                                  replyText[`${complaint.id}_${reply.id}`] || ""
                                }
                                onChange={(e) =>
                                  handleReplyInputChange(
                                    e,
                                    complaint.id,
                                    reply.id
                                  )
                                }
                                style={{
                                  width: "100%",
                                  padding: "12px",
                                  border: "1px solid #D1D5DB",
                                  borderRadius: "8px",
                                  marginBottom: "8px",
                                  boxSizing: "border-box",
                                }}
                              />
                              <button
                                onClick={() =>
                                  replyToComplaint(
                                    complaint.id,
                                    replyText[`${complaint.id}_${reply.id}`] ||
                                      "",
                                    reply.id
                                  )
                                }
                                style={{
                                  backgroundColor: "#2E4053",
                                  color: "white",
                                  padding: "10px 18px",
                                  borderRadius: "8px",
                                  cursor: "pointer",
                                  border: "none",
                                  fontWeight: "bold",
                                  transition: "background-color 0.3s ease",
                                }}
                              >
                                Submit Reply
                              </button>
                            </div>
                          )}
                        </div>

                        {/* Handle Nested Replies */}
                        {reply.replies?.length > 0 && (
                          <div>
                            {reply.replies.map((nestedReply) => (
                              <div
                                key={nestedReply.id}
                                style={{ marginBottom: "12px" }}
                              >
                                <div
                                  style={{
                                    padding: "14px",
                                    backgroundColor: "#E9F1F7",
                                    borderRadius: "8px",
                                    border: `1px solid ${tableBorderColor}`,
                                    marginBottom: "10px",
                                    position: "relative",
                                    boxShadow:
                                      "0px 2px 6px rgba(0, 0, 0, 0.05)",
                                    paddingLeft: `${
                                      20 * (nestedReply.level + 1)
                                    }px`, // Increased padding for nested replies
                                  }}
                                >
                                  <p
                                    style={{
                                      fontSize: "14px",
                                      color: "#333",
                                      marginBottom: "8px",
                                    }}
                                  >
                                    {nestedReply.reply}
                                  </p>
                                  <p
                                    style={{
                                      fontSize: "12px",
                                      color: "gray",
                                      textAlign: "right",
                                    }}
                                  >
                                    Created at:{" "}
                                    {new Date(
                                      nestedReply.created_at
                                    ).toLocaleString()}
                                  </p>

                                  {/* Button to reply to a specific nested reply */}
                                  <button
                                    onClick={() =>
                                      toggleReplyInput(
                                        complaint.id,
                                        nestedReply.id
                                      )
                                    }
                                    style={{
                                      cursor: "pointer",
                                      color: "#2E4053",
                                      fontSize: "14px",
                                      position: "absolute",
                                      right: "12px",
                                      bottom: "12px",
                                      border: "none",
                                      background: "transparent",
                                    }}
                                  >
                                    Reply
                                  </button>

                                  {/* Input for replying to a nested reply */}
                                  {replyInputVisibility[
                                    `${complaint.id}_${nestedReply.id}`
                                  ] && (
                                    <div style={{ marginTop: "12px" }}>
                                      <textarea
                                        placeholder="Enter your reply"
                                        value={
                                          replyText[
                                            `${complaint.id}_${nestedReply.id}`
                                          ] || ""
                                        }
                                        onChange={(e) =>
                                          handleReplyInputChange(
                                            e,
                                            complaint.id,
                                            nestedReply.id
                                          )
                                        }
                                        style={{
                                          width: "100%",
                                          padding: "12px",
                                          border: "1px solid #D1D5DB",
                                          borderRadius: "8px",
                                          marginBottom: "8px",
                                          boxSizing: "border-box",
                                        }}
                                      />
                                      <button
                                        onClick={() =>
                                          replyToComplaint(
                                            complaint.id,
                                            replyText[
                                              `${complaint.id}_${nestedReply.id}`
                                            ] || "",
                                            nestedReply.reply_id
                                          )
                                        }
                                        style={{
                                          backgroundColor: "#2E4053",
                                          color: "white",
                                          padding: "10px 18px",
                                          borderRadius: "8px",
                                          cursor: "pointer",
                                          border: "none",
                                          fontWeight: "bold",
                                          transition:
                                            "background-color 0.3s ease",
                                        }}
                                      >
                                        Submit Reply
                                      </button>
                                    </div>
                                  )}
                                </div>

                                {/* Handle deeper nested replies */}
                                {nestedReply.replies?.length > 0 && (
                                  <div>
                                    {nestedReply.replies.map((deeperReply) => (
                                      <div
                                        key={deeperReply.id}
                                        style={{ marginBottom: "12px" }}
                                      >
                                        <div
                                          style={{
                                            padding: "14px",
                                            backgroundColor: "#C9E2F3",
                                            borderRadius: "8px",
                                            border: `1px solid ${tableBorderColor}`,
                                            marginBottom: "10px",
                                            position: "relative",
                                            boxShadow:
                                              "0px 2px 6px rgba(0, 0, 0, 0.05)",
                                            paddingLeft: `${
                                              20 * (deeperReply.level + 2)
                                            }px`, // Further increased for deeper nesting
                                          }}
                                        >
                                          <p
                                            style={{
                                              fontSize: "14px",
                                              color: "#333",
                                              marginBottom: "8px",
                                            }}
                                          >
                                            {deeperReply.reply}
                                          </p>
                                          <p
                                            style={{
                                              fontSize: "12px",
                                              color: "gray",
                                              textAlign: "right",
                                            }}
                                          >
                                            Created at:{" "}
                                            {new Date(
                                              deeperReply.created_at
                                            ).toLocaleString()}
                                          </p>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>
        ))
      ) : (
        <p>No complaints available.</p>
      )}
      {/* Pagination Section */}
      <div
        style={{ marginTop: "16px", display: "flex", justifyContent: "center" }}
      >
        <Pagination
          totalItem={totalComplaints} // Pass the length of complaints as totalItem
          itemPerPage={itemsPerPage}
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={(newPage) => {
            setCurrentPage(newPage); // Update currentPage
            fetchData(newPage); // Fetch data for the new page
          }}
          fetchItems={(newPage) => fetchData(newPage)} // Pass the fetch function for pagination
        />
      </div>
    </div>
  );
};

export default Complaint;
